module.exports = __webpack_public_path__ + "img/quotation.7c257a57.jpg";